"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = require("lodash");
var utils_1 = require("../utils");
var getVisibilityChangeProps = function () {
    if (typeof document.hidden !== 'undefined') {
        // This covers most cases
        return {
            hidden: 'hidden',
            visibilityChange: 'visibilitychange',
        };
    }
    else if (typeof document.msHidden !== 'undefined') {
        // Internet Explorer and Microsoft Edge
        return {
            hidden: 'msHidden',
            visibilityChange: 'msvisibilitychange',
        };
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        // Older versions of webkit browsers (Chrome, Safari, newer versions of Opera, almost all iOS browsers (including Firefox for iOS))
        return {
            hidden: 'webkitHidden',
            visibilityChange: 'webkitvisibilitychange',
        };
    }
    return undefined;
};
var initialValue = {
    hidden: '',
    visibilityChange: '',
    totalActiveMillis: 0,
    totalAbsentMillis: 0,
    lastEventTime: Date.now(),
    userState: 'active',
};
function useTrackTime(_a) {
    var _b = _a === void 0 ? {
        track: function () { },
    } : _a, track = _b.track, trackingMessage = _b.trackingMessage, trackingProps = _b.trackingProps;
    var timeRef = react_1.useRef(initialValue);
    function getTimeDelta() {
        var lastEventTime = timeRef.current.lastEventTime;
        var now = Date.now();
        return {
            now: now,
            elapsed: now - lastEventTime,
        };
    }
    function setUserActive() {
        var _a = getTimeDelta(), elapsed = _a.elapsed, now = _a.now;
        var _b = timeRef.current, totalAbsentMillis = _b.totalAbsentMillis, userState = _b.userState;
        if (userState === 'inactive') {
            timeRef.current = __assign(__assign({}, timeRef.current), { totalAbsentMillis: totalAbsentMillis + elapsed, lastEventTime: now, userState: 'active' });
        }
    }
    function setUserInactive() {
        var _a = getTimeDelta(), elapsed = _a.elapsed, now = _a.now;
        var _b = timeRef.current, totalActiveMillis = _b.totalActiveMillis, userState = _b.userState;
        if (userState === 'active') {
            timeRef.current = __assign(__assign({}, timeRef.current), { totalActiveMillis: totalActiveMillis + elapsed, lastEventTime: now, userState: 'inactive' });
        }
    }
    function onComponentUnmount() {
        var elapsed = getTimeDelta().elapsed;
        var message = trackingMessage || 'track time';
        var _a = timeRef.current, totalActiveMillis = _a.totalActiveMillis, totalAbsentMillis = _a.totalAbsentMillis, userState = _a.userState;
        track(message, __assign(__assign({}, (trackingProps || {})), { totalActiveTime: totalActiveMillis + (userState === 'active' ? elapsed : 0), totalAbsentTime: totalAbsentMillis + (userState === 'inactive' ? elapsed : 0) }));
        window.removeEventListener('beforeunload', onComponentUnmount);
        document.removeEventListener('mouseenter', setUserActive);
        document.removeEventListener('mouseleave', setUserInactive);
    }
    var onComponentUnmountCallback = react_1.useCallback(onComponentUnmount, []);
    function handleVisibilityChange() {
        var hidden = timeRef.current.hidden;
        if (lodash_1.get(document, [hidden])) {
            setUserInactive();
        }
        else {
            setUserActive();
        }
    }
    function beginEventListening() {
        var visibilityChange = timeRef.current.visibilityChange;
        document.addEventListener(visibilityChange, handleVisibilityChange);
        window.addEventListener('beforeunload', onComponentUnmount);
        document.addEventListener('mouseenter', setUserActive);
        document.addEventListener('mouseleave', setUserInactive);
        setUserActive();
    }
    var beginEventListeningCallback = react_1.useCallback(beginEventListening, []);
    react_1.useEffect(function () {
        if (utils_1.isBrowser()) {
            var visibilityChangeProps = getVisibilityChangeProps();
            if (visibilityChangeProps) {
                timeRef.current = __assign(__assign({}, timeRef.current), visibilityChangeProps);
                beginEventListeningCallback();
            }
        }
        // will be called on component unmount
        return function () {
            if (utils_1.isBrowser()) {
                onComponentUnmountCallback();
            }
        };
        // We only want to run this effect after component mounts, not when beginEventListening or onComponentUnmount changes
    }, [beginEventListeningCallback, onComponentUnmountCallback]);
}
exports.default = useTrackTime;
